import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default{
    async overview(obj){
        try {
            console.log('overview',obj)
            const keys = ['cashflowPeriod'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const { data } = await axios.get(`/dashboard-finance-collection${str}`);
            return data;
        } catch (error) {
            
        }
    }
}